/* eslint-disable eqeqeq */
import React from 'react';
import axios from 'axios';
import { Button, Divider, Grid, Header, Popup, Responsive, Segment, Tab } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-widgets/dist/css/react-widgets.css';

import request from '../../util/request';
import PlaceForm from '../../util/PlaceForm';
import ActivityStatusForm from './FormParts/ActivityStatusForm';
import ParentsInfoForm from './FormParts/ParentsInfoForm';
import BasicInfoForm from './FormParts/BasicInfoForm';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const fetchStudentPersonalInfo = (studentId) => axios.get(`/students/student/personal-information/${studentId}`);
const fetchStudentInfo = (studentId) => axios.get(`/students/student/${studentId}`);
const fetchMunicipality = () => axios.get('/municipalities');


export default class StudentEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            socialStatuses:[],
            personSocialStatuses:[],
            selectedSocialStatusTypes: [],
            activeIndex: 0,
            selectedFile: null,

            newStudentInfo: {},
            //
            genders: [],
            citizenships: [],
            nationalities: [],
            municipalities: [],
            cantons: [],
            entities: [],
            activityStatusTypes: [],
            occupationStatuses: [],
            faculties: [],
            academicTitles: [],

            bihId: null,
            fbihId: null,
            rsId: null,
            bdId: null,


            // FORM DATA
            jmbg: '',
            firstName: '',
            lastName: '',
            maidenName: '',
            dateOfBirth: new Date(),
            gender: null,
            selectedCitizenships: [],
            nationality: null,


            // parents
            fatherFirstName: null,
            fatherLastName: null,
            fatherGender: null,

            motherFirstName: null,
            motherLastName: null,
            motherGender: null,

            occupationStatus: null,
            occupation: null,
            activityStatusType: null,

            // error fields
            genderErr: false,
            citizenshipsErr: false,
            activityStatusTypeErr: false,

            placeOfResidenceCountryErr: false,
            placeOfResidenceEntityErr: false,
            placeOfResidenceCantonErr: false,
            placeOfResidenceMunicipalityErr: false,
            placeOfResidencePlaceErr: false,
            placeOfResidenceAddressErr: false,

            placeOfBirthCountryErr: false,
            placeOfBirthEntityErr: false,
            placeOfBirthCantonErr: false,
            placeOfBirthMunicipalityErr: false,
            placeOfBirthPlaceErr: false,

            placeOfCurrentResidenceCountryErr: false,
            placeOfCurrentResidenceEntityErr: false,
            placeOfCurrentResidenceCantonErr: false,
            placeOfCurrentResidenceMunicipalityErr: false,
            placeOfCurrentResidencePlaceErr: false,
            placeOfCurrentResidenceAddressErr: false,

            // father and mother info
            occupationStatusF: null,
            occupationF: null,
            activityStatusTypeF: null,

            occupationStatusM: null,
            occupationM: null,
            activityStatusTypeM: null,

            facultyChanges: [],

            placeOfResidence: {
                id: null,
                optLock: null,
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfCurrentResidence: {
                id: null,
                optLock: null,
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfBirth: {
                id: null,
                optLock: null,
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            selectedAcademicTitles: [],

            test: {},
            studentId: null,
            optLock: null,
            wizardStep: 1,
            loader: true

        };

        this.reset = this.reset.bind(this);

        this.getAllInfo = this.getAllInfo.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateOfBirthChange = this.handleDateOfBirthChange.bind(this);

        this.onSubmit = this.onSubmit.bind(this);
        this.showNationality = this.showNationality.bind(this);

        this.onChangeCustom = this.onChangeCustom.bind(this);

        this.removeActivityStatus = this.removeActivityStatus.bind(this);
        this.addNewAfterCreate = this.addNewAfterCreate.bind(this);

        this.onAddNewAcademicTitle = this.onAddNewAcademicTitle.bind(this);
        this.onDeleteAcademicTitle = this.onDeleteAcademicTitle.bind(this);
        this.getDefaultActivityStatusId = this.getDefaultActivityStatusId.bind(this);

        this.onPlaceChange = this.onPlaceChange.bind(this);
        this.getActiveStatusId = this.getActiveStatusId.bind(this);
    }

    UNSAFE_componentWillMount() {

        this.getAllInfo(false);

        axios.get('/entities')
            .then(res => {
                this.setState({ rsId: res.data.find(el => el._key === 'rs').id, bdId: res.data.find(el => el._key === 'bd').id });
            });
    }


    getAllInfo(edited) {

        console.log('studentId', JSON.parse(localStorage.getItem('student')).studentId);
        this.setState({loader: true})
        request.fetchGendersWithDefaultKeys()
            .then(({ genders, defaultMaleGenderId, defaultFemaleGenderId }) => {
                this.setState({ genders, fatherGender: defaultMaleGenderId, motherGender: defaultFemaleGenderId });
            }).catch(err => console.log(err));
        request.fetchNationalitiesWithDefaultKey()
            .then(({ nationalities, defaultUnknownNationalityId }) => {
                this.setState({ nationalities, nationality: defaultUnknownNationalityId });
            }).catch(err => console.log(err));
        request.fetchCitizenships()
            .then(citizenships => this.setState({ citizenships }));
        request.fetchActivityStatusTypes()
            .then(activityStatusTypes => this.setState({
                activityStatusTypes,
                activityStatusType: this.getDefaultActivityStatusId(activityStatusTypes),
                activeStatusId: this.getActiveStatusId(activityStatusTypes)
            }));
        request.fetchOccupationStatuses()
            .then(occupationStatuses => this.setState({ occupationStatuses }));
        // request.fetchRawFaculties()
        //     .then(faculties => this.setState({ faculties }));
        request.fetchCountriesWithDefaultKey()
            .then(({ bihId }) => this.setState({ bihId }));
        request.fetchEntitiesWithDefaultKey()
            .then(({ fbihId }) => this.setState({ fbihId }));
        request.fetchAcademicTitles()
            .then(academicTitles => this.setState({ academicTitles }));
        request.fetchSocialStatuses()
            .then(socialStatuses => this.setState({ socialStatuses }));

        axios.all([fetchStudentPersonalInfo(JSON.parse(localStorage.getItem('student')).studentId), fetchStudentInfo(JSON.parse(localStorage.getItem('student')).studentId), fetchMunicipality()])
            .then(axios.spread((personalInfoRes, studentInfoRes, municipalitiesRes) => {
                const personalInfo = personalInfoRes.data;
                this.setState({ newStudentInfo: personalInfo });
                console.log(' this.setState({newStudentInfo: personalInfo});', personalInfo);
                const studentInfo = studentInfoRes.data;
                const municipalities = municipalitiesRes.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: el.name,
                    cantonId: el.canton != null ? el.canton.id : ''
                }));
                const selectedCitizenships = [];
                const selectedSocialStatusTypes = [];
                personalInfo.citizenships && personalInfo.citizenships.map(el => { selectedCitizenships.push(el.country.id); });
                personalInfo.personSocialStatuses && personalInfo.personSocialStatuses.map(el => { selectedSocialStatusTypes.push(el.socialStatusType.id); });

                this.setState({
                    optLock: studentInfo.optLock,
                    studentId: personalInfo.id,
                    comment: personalInfo.comment,
                    // // FORM DATA
                    jmbg: personalInfo.jmbg ? personalInfo.jmbg : null,
                    firstName: personalInfo.firstName ? personalInfo.firstName : null,
                    lastName: personalInfo.lastName ? personalInfo.lastName : null,
                    dateOfBirth: new Date(personalInfo.dateOfBirth),
                    gender: studentInfo.gender ? studentInfo.gender.id : null,
                    maidenName: personalInfo.maidenName ? personalInfo.maidenName : null,
                    selectedCitizenships,
                    selectedSocialStatusTypes,
                    nationality: studentInfo.nationality ? studentInfo.nationality.id : null,
                    contacts: personalInfo.contacts ? personalInfo.contacts : null,

                    personSocialStatuses: personalInfo.personSocialStatuses,

                    // parents
                    fatherFirstName: personalInfo.fatherFirstName ? personalInfo.fatherFirstName : null,
                    fatherLastName: personalInfo.fatherLastName ? personalInfo.fatherLastName : null,
                    fatherId: studentInfo.father ? studentInfo.father.id : null,
                    fatherOptLock: studentInfo.father ? studentInfo.father.optLock : null,

                    occupationStatusF: (studentInfo.father && studentInfo.father.activityStatus && studentInfo.father.activityStatus.occupationStatus) ? studentInfo.father.activityStatus.occupationStatus.id : null,
                    occupationF: (studentInfo.father && studentInfo.father.activityStatus && studentInfo.father.activityStatus.occupation) ? studentInfo.father.activityStatus.occupation : null,
                    activityStatusTypeF: (studentInfo.father && studentInfo.father.activityStatus && studentInfo.father.activityStatus.status) ? studentInfo.father.activityStatus.status.id : null,

                    // retain old parents gender state

                    motherFirstName: personalInfo.motherFirstName ? personalInfo.motherFirstName : null,
                    motherLastName: personalInfo.motherLastName ? personalInfo.motherLastName : null,
                    motherId: studentInfo.mother ? studentInfo.mother.id : null,
                    motherOptLock: studentInfo.mother ? studentInfo.mother.optLock : null,

                    occupationStatusM: (studentInfo.mother && studentInfo.mother.activityStatus && studentInfo.mother.activityStatus.occupationStatus) ? studentInfo.mother.activityStatus.occupationStatus.id : null,
                    occupationM: (studentInfo.mother && studentInfo.mother.activityStatus && studentInfo.mother.activityStatus.occupation) ? studentInfo.mother.activityStatus.occupation : null,
                    activityStatusTypeM: (studentInfo.mother && studentInfo.mother.activityStatus && studentInfo.mother.activityStatus.status) ? studentInfo.mother.activityStatus.status.id : null,



                    occupationStatus: (studentInfo.activityStatus && studentInfo.activityStatus.occupationStatus) ? studentInfo.activityStatus.occupationStatus.id : null,
                    occupation: (studentInfo.activityStatus && studentInfo.activityStatus.occupation) ? studentInfo.activityStatus.occupation : null,
                    activityStatusType: (studentInfo.activityStatus && studentInfo.activityStatus.status) ? studentInfo.activityStatus.status.id : null,

                    facultyChanges: studentInfo.facultyChanges ? studentInfo.facultyChanges : [],

                    placeOfResidence: {
                        id: studentInfo.residence ? studentInfo.residence.id : null,
                        optLock: studentInfo.residence ? studentInfo.residence.optLock : null,
                        country: (studentInfo.residence && studentInfo.residence.place && studentInfo.residence.place.country) ? studentInfo.residence.place.country.id : null,
                        entity: (studentInfo.residence && studentInfo.residence.place && studentInfo.residence.place.entity) ? studentInfo.residence.place.entity.id : null,
                        canton: (studentInfo.residence && studentInfo.residence.place && studentInfo.residence.place.canton) ? studentInfo.residence.place.canton.id : null,
                        municipality: (studentInfo.residence && studentInfo.residence.place && studentInfo.residence.place.municipality) ? studentInfo.residence.place.municipality.id : null,
                        place: studentInfo.residence ? studentInfo.residence.place.name : null,
                        placeId: studentInfo.residence ? studentInfo.residence.place.id : null,
                        placeOptLock: studentInfo.residence ? studentInfo.residence.place.optLock : null,
                        address: (studentInfo.residence && studentInfo.residence.street) ? studentInfo.residence.street : null
                    },

                    placeOfCurrentResidence: {
                        id: studentInfo.currentResidence ? studentInfo.currentResidence.id : null,
                        optLock: studentInfo.currentResidence ? studentInfo.currentResidence.optLock : null,
                        country: (studentInfo.currentResidence && studentInfo.currentResidence.place && studentInfo.currentResidence.place.country) ? studentInfo.currentResidence.place.country.id : null,
                        entity: (studentInfo.currentResidence && studentInfo.currentResidence.place && studentInfo.currentResidence.place.entity) ? studentInfo.currentResidence.place.entity.id : null,
                        canton: (studentInfo.currentResidence && studentInfo.currentResidence.place && studentInfo.currentResidence.place.canton) ? studentInfo.currentResidence.place.canton.id : null,
                        municipality: (studentInfo.currentResidence && studentInfo.currentResidence.place && studentInfo.currentResidence.place.municipality) ? studentInfo.currentResidence.place.municipality.id : null,
                        place: studentInfo.currentResidence ? studentInfo.currentResidence.place.name : null,
                        placeId: studentInfo.currentResidence ? studentInfo.currentResidence.place.id : null,
                        placeOptLock: studentInfo.currentResidence ? studentInfo.currentResidence.place.optLock : null,
                        address: studentInfo.currentResidence ? studentInfo.currentResidence.street : null
                    },

                    placeOfBirth: {
                        id: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.id : null,
                        optLock: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.optLock : null,
                        country: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.country ? studentInfo.placeOfBirth.country.id : null : null,
                        entity: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.entity ? studentInfo.placeOfBirth.entity.id : null : null,
                        canton: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.canton ? studentInfo.placeOfBirth.canton.id : null : null,
                        municipality: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.municipality ? studentInfo.placeOfBirth.municipality.id : null : null,
                        place: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.name : null,
                        placeId: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.id : null,
                        placeOptLock: studentInfo.placeOfBirth ? studentInfo.placeOfBirth.optLock : null,
                        address: ''
                    },

                    activeStatusId: null,
                    municipalities,
                    loader: false
                });

                if (edited) {
                    console.log('this.state.newStudentInfo', this.state.newStudentInfo);
                    this.props.changeStep(this.state.newStudentInfo);
                }

            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch results');
            });


    }

    handleDateOfBirthChange(date) {
        this.setState({ dateOfBirth: date });
    }
    addNewAfterCreate() {
        this.setState({ wizardStep: 1 });
    }

    getActiveStatusId(activityStatusTypes) {
        const selected = activityStatusTypes.find(el => el.text === 'zaposlen');
        if (selected && selected.key) return selected.key;
        return '';
    }

    getDefaultActivityStatusId(activityStatusTypes) {
        const selected = activityStatusTypes.find(el => el.text === 'neaktivan');
        if (selected && selected.key) return selected.key;
        return '';
    }
    onSubmit() {
        if (!this.state.jmbg || !this.state.firstName || !this.state.lastName || !this.state.gender
            || (this.state.selectedCitizenships.length === 0) || !this.state.activityStatusType ||

            !this.state.placeOfResidence.country ||
            ((this.state.placeOfResidence.country && this.state.placeOfResidence.country === this.state.bihId) && !this.state.placeOfResidence.entity) ||
            ((this.state.placeOfResidence.entity && this.state.placeOfResidence.entity === this.state.fbihId)
                && (!this.state.placeOfResidence.canton || !this.state.placeOfResidence.municipality))
            || (this.state.placeOfResidence.entity && this.state.placeOfResidence.entity === this.state.rsId && !this.state.placeOfResidence.municipality)
            || !this.state.placeOfResidence.address || !this.state.placeOfResidence.place ||

            !this.state.placeOfBirth.country ||
            ((this.state.placeOfBirth.country && this.state.placeOfBirth.country === this.state.bihId) && !this.state.placeOfBirth.entity) ||
            ((this.state.placeOfBirth.entity && this.state.placeOfBirth.entity === this.state.fbihId)
                && (!this.state.placeOfBirth.canton || !this.state.placeOfBirth.municipality))
            || (this.state.placeOfBirth.entity && this.state.placeOfBirth.entity === this.state.rsId && !this.state.placeOfBirth.municipality)
            || !this.state.placeOfBirth.place ||

            (this.state.placeOfCurrentResidence.country &&
                (!this.state.placeOfCurrentResidence.place || !this.state.placeOfCurrentResidence.address
                || ((this.state.placeOfCurrentResidence.country === this.state.bihId) && !this.state.placeOfCurrentResidence.entity))
                || (this.state.placeOfCurrentResidence.entity && this.state.placeOfCurrentResidence.entity === this.state.fbihIdb
                    && (!this.state.placeOfCurrentResidence.canton || !this.state.placeOfCurrentResidence.municipality))
                || (this.state.placeOfCurrentResidence.entity && this.state.placeOfCurrentResidence.entity === this.state.rsId && !this.state.placeOfCurrentResidence.municipality)
            )
        ) {
            toast('Niste unijeli sva obavezna polja!');
            if (!this.state.jmbg) { this.setState({ jmbgErr: true }); } else { this.setState({ jmbgErr: false }); }
            if (!this.state.firstName) { this.setState({ firstNameErr: true }); } else { this.setState({ firstNameErr: false }); }
            if (!this.state.lastName) { this.setState({ lastNameErr: true }); } else { this.setState({ lastNameErr: false }); }
            if (!this.state.gender) { this.setState({ genderErr: true }); } else { this.setState({ genderErr: false }); }
            if (this.state.selectedCitizenships.length === 0) { this.setState({ citizenshipsErr: true }); } else { this.setState({ citizenshipsErr: false }); }

            if (!this.state.placeOfResidence.country) { this.setState({ placeOfResidenceCountryErr: true }); } else { this.setState({ placeOfResidenceCountryErr: false }); }
            if (!this.state.placeOfResidence.address) { this.setState({ placeOfResidenceAddressErr: true }); } else { this.setState({ placeOfResidenceAddressErr: false }); }
            if (!this.state.placeOfResidence.place) { this.setState({ placeOfResidencePlaceErr: true }); } else { this.setState({ placeOfResidencePlaceErr: false }); }

            if (this.state.placeOfResidence.country === this.state.bihId) {
                if (!this.state.placeOfResidence.entity) { this.setState({ placeOfResidenceEntityErr: true }); } else { this.setState({ placeOfResidenceEntityErr: false }); }
                if (this.state.placeOfResidence.entity === this.state.fbihId) {
                    if (!this.state.placeOfResidence.canton) { this.setState({ placeOfResidenceCantonErr: true }); } else { this.setState({ placeOfResidenceCantonErr: false }); }
                    if (!this.state.placeOfResidence.municipality) { this.setState({ placeOfResidenceMunicipalityErr: true }); } else { this.setState({ placeOfResidenceMunicipalityErr: false }); }
                }
                if (this.state.placeOfResidence.entity === this.state.rsId) {
                    if (!this.state.placeOfResidence.municipality) { this.setState({ placeOfResidenceMunicipalityErr: true }); } else { this.setState({ placeOfResidenceMunicipalityErr: false }); }
                }
            }

            if (!this.state.placeOfBirth.country) { this.setState({ placeOfBirthCountryErr: true }); } else { this.setState({ placeOfBirthCountryErr: false }); }
            if (!this.state.placeOfBirth.place) { this.setState({ placeOfBirthPlaceErr: true }); } else { this.setState({ placeOfBirthPlaceErr: false }); }

            if (this.state.placeOfBirth.country === this.state.bihId) {
                if (!this.state.placeOfBirth.entity) { this.setState({ placeOfBirthEntityErr: true }); } else { this.setState({ placeOfBirthEntityErr: false }); }
                if (this.state.placeOfBirth.entity === this.state.fbihId) {
                    if (!this.state.placeOfBirth.canton) { this.setState({ placeOfBirthCantonErr: true }); } else { this.setState({ placeOfBirthCantonErr: false }); }
                    if (!this.state.placeOfBirth.municipality) { this.setState({ placeOfBirthMunicipalityErr: true }); } else { this.setState({ placeOfBirthMunicipalityErr: false }); }
                }
                if (this.state.placeOfBirth.entity === this.state.rsId) {
                    if (!this.state.placeOfBirth.municipality) { this.setState({ placeOfBirthMunicipalityErr: true }); } else { this.setState({ placeOfBirthMunicipalityErr: false }); }
                }
            }

            if (!this.state.activityStatusType) { this.setState({ activityStatusTypeErr: true }); } else { this.setState({ activityStatusTypeErr: false }); }

            if (this.state.placeOfCurrentResidence.country === this.state.bihId) {
                if (!this.state.placeOfCurrentResidence.entity) { this.setState({ placeOfCurrentResidenceEntityErr: true }); } else { this.setState({ placeOfCurrentResidenceEntityErr: false }); }
                if (this.state.placeOfCurrentResidence.entity === this.state.fbihId) {
                    if (!this.state.placeOfCurrentResidence.canton) { this.setState({ placeOfCurrentResidenceCantonErr: true }); } else { this.setState({ placeOfCurrentResidenceCantonErr: false }); }
                    if (!this.state.placeOfCurrentResidence.municipality) { this.setState({ placeOfCurrentResidenceMunicipalityErr: true }); } else { this.setState({ placeOfCurrentResidenceMunicipalityErr: false }); }
                }
                if (this.state.placeOfCurrentResidence.entity === this.state.rsId) {
                    if (!this.state.placeOfCurrentResidence.municipality) { this.setState({ placeOfCurrentResidenceMunicipalityErr: true }); } else { this.setState({ placeOfCurrentResidenceMunicipalityErr: false }); }
                }
            }
        } else {
            const requestData = request.formatAndValidateForRequest(this.state);
            this.setState({ test: requestData });

            axios.put('/students/student/', { ...requestData.data })
                .then(res => {
                    toast('Izmjena studenta je uspješno izvršena.');
                    this.getAllInfo(true);
                    this.setState({
                        citizenshipsErr: false,
                        activityStatusTypeErr: false,
                        genderErr: false,

                        placeOfResidenceCountryErr: false,
                        placeOfResidenceEntityErr: false,
                        placeOfResidenceCantonErr: false,
                        placeOfResidenceMunicipalityErr: false,
                        placeOfResidencePlaceErr: false,
                        placeOfResidenceAddressErr: false,

                        placeOfBirthCountryErr: false,
                        placeOfBirthEntityErr: false,
                        placeOfBirthCantonErr: false,
                        placeOfBirthMunicipalityErr: false,
                        placeOfBirthPlaceErr: false,

                        placeOfCurrentResidenceCountryErr: false,
                        placeOfCurrentResidenceEntityErr: false,
                        placeOfCurrentResidenceCantonErr: false,
                        placeOfCurrentResidenceMunicipalityErr: false,
                        placeOfCurrentResidencePlaceErr: false,
                        placeOfCurrentResidenceAddressErr: false,
                    });
                }).catch(err => {
                if (err.response.data === 'Person with this JMBG already exists!') {
                    toast('Došlo je do greške! Student sa tim JMBG-om već postoji.');
                }

                    toast('Došlo je do greške! Izmjena studenta nije uspjela.');
                    this.getAllInfo(false);
                    this.setState({
                        citizenshipsErr: false,
                        activityStatusTypeErr: false,
                        genderErr: false,

                        placeOfResidenceCountryErr: false,
                        placeOfResidenceEntityErr: false,
                        placeOfResidenceCantonErr: false,
                        placeOfResidenceMunicipalityErr: false,
                        placeOfResidencePlaceErr: false,
                        placeOfResidenceAddressErr: false,

                        placeOfBirthCountryErr: false,
                        placeOfBirthEntityErr: false,
                        placeOfBirthCantonErr: false,
                        placeOfBirthMunicipalityErr: false,
                        placeOfBirthPlaceErr: false,

                        placeOfCurrentResidenceCountryErr: false,
                        placeOfCurrentResidenceEntityErr: false,
                        placeOfCurrentResidenceCantonErr: false,
                        placeOfCurrentResidenceMunicipalityErr: false,
                        placeOfCurrentResidencePlaceErr: false,
                        placeOfCurrentResidenceAddressErr: false,
                    });
                });
    }
    }
    handleInputChange(e, { name, value }) {
        if (name === 'gender') {this.setState({maidenName:''})};
        this.setState({ [name]: value });
    }
    showNationality() {
        return !!this.state.selectedCitizenships.find(el => this.state.bihId === el);
    }

    onChangeCustom(name, value, formName) {
        this.setState({ [formName]: { ...this.state[formName], [name]: value } });
    }
    removeActivityStatus() {
        this.setState({ occupationStatus: null, activityStatusType: null, occupation: '' });
    }
    onAddNewAcademicTitle(newAcademicTitle) {
        const { selectedAcademicTitles } = this.state;
        this.setState({ selectedAcademicTitles: [...selectedAcademicTitles, newAcademicTitle] });
    }
    onDeleteAcademicTitle(index) {
        const { selectedAcademicTitles } = this.state;
        const filteredAcademicTitles = selectedAcademicTitles.filter((el, i) => i != index);
        this.setState({ selectedAcademicTitles: filteredAcademicTitles });
    }
    onPlaceChange(values, formName) {
        this.setState({ [formName]: values });
    }


    reset() {
        this.setState({
            //
            genders: [],
            citizenships: [],
            nationalities: [],
            educationLevels: [],
            municipalities: [],
            cantons: [],
            entities: [],
            activityStatusTypes: [],
            occupationStatuses: [],
            faculties: [],
            academicTitles: [],

            bihId: null,
            fbihId: null,


            // FORM DATA
            jmbg: '',
            firstName: '',
            lastName: '',
            maidenName: '',
            dateOfBirth: new Date(),
            gender: null,
            selectedCitizenships: [],
            nationality: null,


            // parents
            fatherFirstName: null,
            fatherLastName: null,
            fatherGender: null,

            motherFirstName: null,
            motherLastName: null,
            motherGender: null,

            contactTypes: [],
            contacts: [],
            // previousEducations: [],

            occupationStatus: null,
            occupation: null,
            activityStatusType: null,

            // father and mother info
            occupationStatusF: null,
            occupationF: null,
            activityStatusTypeF: null,

            occupationStatusM: null,
            occupationM: null,
            activityStatusTypeM: null,

            facultyChanges: [],

            placeOfResidence: {
                id: null,
                optLock: null,
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfCurrentResidence: {
                id: null,
                optLock: null,
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfBirth: {
                id: null,
                optLock: null,
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            selectedAcademicTitles: [],

            test: {},
            studentId: null,
            optLock: null,
        });
    }

    handleTabChange = (e, { activeIndex }) => {
        this.setState({ activeIndex });
    };


    render() {

        const panes = [
            {
                menuItem: 'Osnovne informacije',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <BasicInfoForm
                        firstName={this.state.firstName}
                        jmbg={this.state.jmbg}
                        lastName={this.state.lastName}
                        maidenName={this.state.maidenName}
                        dateOfBirth={this.state.dateOfBirth}
                        handleInputChange={this.handleInputChange}
                        handleDateChange={this.handleDateOfBirthChange}
                        gender={this.state.gender}
                        genders={this.state.genders}
                        citizenships={this.state.citizenships}
                        selectedCitizenships={this.state.selectedCitizenships}
                        nationalities={this.state.nationalities}
                        nationality={this.state.nationality}
                        bihId={this.state.bihId}
                        formName="basicInfo"
                        jmbgErr={this.state.jmbgErr}
                        firstNameErr={this.state.firstNameErr}
                        lastNameErr={this.state.lastNameErr}
                        genderErr={this.state.genderErr}
                        citizenshipsErr={this.state.citizenshipsErr}
                        socialStatuses={this.state.socialStatuses}
                        selectedSocialStatusTypes={this.state.selectedSocialStatusTypes}
                    />
                </Tab.Pane>),
            },
            {
                menuItem: 'Mjesto rođenja',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <PlaceForm
                        values={this.state.placeOfBirth}
                        formName="placeOfBirth"
                        onPlaceChange={this.onPlaceChange}
                        rsId={this.state.rsId}
                        //bdId={this.state.bdId}
                        countryErr={this.state.placeOfBirthCountryErr}
                        entityErr={this.state.placeOfBirthEntityErr}
                        cantonErr={this.state.placeOfBirthCantonErr}
                        municipalityErr={this.state.placeOfBirthMunicipalityErr}
                        placeErr={this.state.placeOfBirthPlaceErr}
                        municipalitiesStart={this.state.placeOfBirth.canton ? this.state.municipalities.filter(el => el.cantonId === this.state.placeOfBirth.canton)
                            : this.state.placeOfBirth.entity ? this.state.municipalities.filter(el => el.entity && el.entity.id === this.state.placeOfBirth.entity) : []}
                        noAdress
                    />


                </Tab.Pane>),
            },
            {
                menuItem: 'Informacije o roditeljima',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <ParentsInfoForm
                        genders={this.state.genders}
                        fatherFirstName={this.state.fatherFirstName}
                        fatherLastName={this.state.fatherLastName}
                        fatherGender={this.state.fatherGender}
                        motherFirstName={this.state.motherFirstName}
                        motherLastName={this.state.motherLastName}
                        motherGender={this.state.motherGender}
                        onChange={this.handleInputChange}
                        edit

                        activityStatusTypes={this.state.activityStatusTypes}
                        occupationStatuses={this.state.occupationStatuses}

                        activityStatusTypeM={this.state.activityStatusTypeM}
                        occupationStatusM={this.state.occupationStatusM}
                        occupationM={this.state.occupationM}

                        activityStatusTypeF={this.state.activityStatusTypeF}
                        occupationStatusF={this.state.occupationStatusF}
                        occupationF={this.state.occupationF}

                        handleInputChange={this.handleInputChange}
                        removeActivityStatus={this.removeActivityStatus}
                        activeStatusId={this.getActiveStatusId(this.state.activityStatusTypes)}
                    />
                </Tab.Pane>),
            },
            {
                menuItem: 'Prebivalište i boravište',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <Grid columns="equal" centered className="stackable">
                            <Grid.Row streched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4">Prebivalište</Header>
                                    </Divider>
                                    <PlaceForm
                                        values={this.state.placeOfResidence}
                                        formName="placeOfResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        rsId={this.state.rsId}
                                      ///  bdId={this.state.bdId}
                                        countryErr={this.state.placeOfResidenceCountryErr}
                                        entityErr={this.state.placeOfResidenceEntityErr}
                                        cantonErr={this.state.placeOfResidenceCantonErr}
                                        municipalityErr={this.state.placeOfResidenceMunicipalityErr}
                                        placeErr={this.state.placeOfResidencePlaceErr}
                                        addressErr={this.state.placeOfResidenceAddressErr}
                                        municipalitiesStart={this.state.placeOfResidence.canton ? this.state.municipalities.filter(el => el.cantonId === this.state.placeOfResidence.canton)
                                            : this.state.placeOfResidence.entity ? this.state.municipalities.filter(el => el.entity && el.entity.id === this.state.placeOfResidence.entity) : []}
                                    />
                                   </Grid.Column>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4">Boravište</Header>
                                    </Divider>
                                    <PlaceForm
                                        values={this.state.placeOfCurrentResidence}
                                        formName="placeOfCurrentResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        rsId={this.state.rsId}
                                       // bdId={this.state.bdId}
                                        countryErr={this.state.placeOfCurrentResidenceCountryErr}
                                        entityErr={this.state.placeOfCurrentResidenceEntityErr}
                                        cantonErr={this.state.placeOfCurrentResidenceCantonErr}
                                        municipalityErr={this.state.placeOfCurrentResidenceMunicipalityErr}
                                        placeErr={this.state.placeOfCurrentResidencePlaceErr}
                                        addressErr={this.state.placeOfCurrentResidenceAddressErr}
                                        municipalitiesStart={this.state.placeOfCurrentResidence.canton ? this.state.municipalities.filter(el => el.cantonId === this.state.placeOfCurrentResidence.canton)
                                            : this.state.placeOfCurrentResidence.entity ? this.state.municipalities.filter(el => el.entity && el.entity.id === this.state.placeOfCurrentResidence.entity) : []}
                                    />
                                    </Grid.Column>
                            </Grid.Row></Grid>
                    </div>
                </Tab.Pane>),
            },
            {
                menuItem: 'Status u aktivnosti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <ActivityStatusForm
                        activityStatusTypes={this.state.activityStatusTypes}
                        occupationStatuses={this.state.occupationStatuses}
                        activityStatusType={this.state.activityStatusType}
                        occupationStatus={this.state.occupationStatus}
                        occupation={this.state.occupation}
                        handleInputChange={this.handleInputChange}
                        removeActivityStatus={this.removeActivityStatus}
                        activeStatusId={this.getActiveStatusId(this.state.activityStatusTypes)}
                        errorStatus={this.state.activityStatusTypeErr}
                        edit
                    />
                </Tab.Pane>),
            },
            // {
            //     menuItem: 'Fotografija studenta',
            //     render: () => (<Tab.Pane attached={false} as={Responsive}>
            //
            //             <div style={{textAlign: "center", verticalAlign:"middle"}}>
            //                 <br/>
            //                 <br/>
            //                 <br/>
            //                 <Button as='div' labelPosition='right'>
            //                     <Button color='blue' as="label" htmlFor="file" type="button"  onChange={this.onFileChange}>
            //                         <Icon name='upload' />
            //                     </Button>
            //                     <Label  style={{cursor:'none'}} basic pointing='left'>
            //                         {this.state.selectedFile === null ?
            //                             'Odaberite novu fotografiju'
            //                             : 'Nova fotografija je odabrana'
            //                         }
            //                     </Label>
            //                 </Button>
            //
            //                 <Input type="file" id="file" style={{ display: "none" }} onChange={this.onFileChange} />
            //                 <br/>
            //                 <br/>
            //
            //                 <Button disabled={this.state.selectedFile === null} color="blue" onClick={this.onFileUpload}>
            //                     Sačuvaj novu fotografiju
            //                 </Button>
            //                 <Button disabled={this.state.selectedFile === null} color="blue" basic onClick={()=>this.setState({selectedFile: null})}>
            //                     Poništi promjenu fotografije
            //                 </Button>
            //             </div>
            //
            //        </Tab.Pane>),
            // },
        ];

        return (
            <div>
                <Divider horizontal>
                    <Header as="h4">
                        Izmjena podataka
                    </Header>
                </Divider>
                <br/>

                <Tab
                    panes={panes}
                    menu={{
                        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                    }}
                    onTabChange={this.handleTabChange}
                    activeIndex={this.state.activeIndex}
                    grid={{ paneWidth: 13, tabWidth: 3 }}
                />

                <Segment vertical clearing/>
                <Segment vertical clearing>
                    <Grid columns={3}>
                        <Grid.Column ><Button  compact icon='left arrow'  basic color='blue'  disabled={this.state.activeIndex === 0}
                                               onClick={()=> this.setState({activeIndex: this.state.activeIndex-1})} floated="left"/>
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <Popup
                                content="Sačuvaj izmjene"
                                position="top center"
                                trigger={<Button basic color={'green'} onClick={this.onSubmit} compact circular icon={'check'}/>}
                            />
                            <Popup
                                content="Odustani"
                                position="top center"
                                trigger={ <Button icon={'close'} basic color={'blue'} circular compact  onClick={()=>this.props.changeStep(this.props.personData)}/>}
                            />


                        </Grid.Column>
                        <Grid.Column >
                            <Button  icon='right arrow' floated={'right'} basic color='blue' compact disabled={this.state.activeIndex >= 4}
                                     onClick={()=> this.setState({activeIndex: this.state.activeIndex+1})} />
                        </Grid.Column>
                    </Grid>
                </Segment>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentCreateAndEdit/StudentEdit.js